"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _gql;
Object.defineProperty(exports, "__esModule", { value: true });
exports.subgraphUrlFromChainId = void 0;
const connect_thegraph_1 = require("@aragon/connect-thegraph");
const queries = __importStar(require("./queries"));
const parsers_1 = require("./parsers");
const helpers_1 = require("../helpers");
const tasks_1 = require("./parsers/tasks");
function subgraphUrlFromChainId(chainId) {
    // Rinkeby
    if (chainId === 4) {
        return 'https://api.thegraph.com/subgraphs/name/p2pmodels/aragon-rr-rinkeby-staging';
    }
    return null;
}
exports.subgraphUrlFromChainId = subgraphUrlFromChainId;
class RoundRobinConnectorTheGraph {
    constructor(config) {
        _gql.set(this, void 0);
        if (!config.subgraphUrl) {
            throw new Error('RoundRobinConnectorTheGraph requires subgraphUrl to be passed.');
        }
        __classPrivateFieldSet(this, _gql, new connect_thegraph_1.GraphQLWrapper(config.subgraphUrl, {
            pollInterval: config.pollInterval,
            verbose: config.verbose,
        }));
    }
    async disconnect() {
        __classPrivateFieldGet(this, _gql).close();
    }
    onConfig(id, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.CONFIG('subscription'), { id }, callback, (result) => parsers_1.parseConfig(result, this));
    }
    async user(appAddress, userId) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.USER('query'), { id }, (result) => parsers_1.parseUser(result, this));
    }
    onUser(appAddress, userId, callback) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.USER('subscription'), { id }, callback, (result) => parsers_1.parseUser(result, this));
    }
    async tasksForUser(appAddress, userId, statuses, first, skip) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.USER_TASKS_BY_STATUS('query'), { statuses, userId: id, first, skip }, (result) => parsers_1.parseTasks(result, this));
    }
    onTasksForUser(appAddress, userId, statuses, first, skip, callback) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        console.log(`user id: ${id}`);
        console.log(`statuses`);
        console.log(statuses);
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.USER_TASKS_BY_STATUS('subscription'), { statuses, userId: id, first, skip }, callback, (result) => parsers_1.parseTasks(result, this));
    }
    async rejectedTasksForUser(appAddress, userId
    // first: number,
    // skip: number
    ) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.USER_REJECTED_TASKS('query'), { id }, (result) => tasks_1.parseRejectedTasks(result, this));
    }
    onRejectedTasksForUser(appAddress, userId, 
    // first: number,
    // skip: number,
    callback) {
        const id = helpers_1.buildUserEntityId(appAddress, userId);
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.USER_REJECTED_TASKS('subscription'), { id }, callback, (result) => tasks_1.parseRejectedTasks(result, this));
    }
}
exports.default = RoundRobinConnectorTheGraph;
_gql = new WeakMap();
//# sourceMappingURL=connector.js.map